import { Button, Typography } from "antd";
import oopsImg from '../../../../assets/oops.png';
import { useNavigate } from "react-router";

const { Title, Paragraph } = Typography;

type NotFoundProps = {
  title?: string;
  description?: string;
  linkText?: string;
  onLinkClick?: () => void;
};

const NotFoundPage = ({ title, description, linkText, onLinkClick }: NotFoundProps) => {

  const navigate = useNavigate();
  const clickHandler = () => {
    if (onLinkClick) {
      onLinkClick();
    } else {
      navigate("/");
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        textAlign: "center",
        padding: 16,
      }}
    >
      <img
        src={oopsImg}
        alt="404 Not Found"
        style={{ maxWidth: "300px", width: "100%", marginBottom: 24 }}
      />
      <Title level={2}>{title || "Page not found"}</Title>
      <Paragraph type="secondary">
        {description || "Sorry, the page you are looking for does not exist."}
      </Paragraph>
      <Button type="primary" onClick={clickHandler}>
        {linkText || "Go Home"}
      </Button>
    </div>
  );
};

export default NotFoundPage;